import React, { useState, useEffect } from "react";

// styles
import styles from 'styles/about-us.module.scss'

// components
import { Col, Row } from 'avena-components';

import Image from 'next/image';

import VStack from "components/vstack/vstack";
import ContactUsForm from "components/contact-us-form";


const AboutUs = () => {
    const [isMobile, setIsMobile] = useState(false);

    useEffect(() => {
        if (typeof window !== 'undefined') {
            if (window.innerWidth < 768) {
                setIsMobile(true);
            } else {
                setIsMobile(false);
            }
            window.addEventListener('resize', () => {
                if (window.innerWidth < 768) {
                    setIsMobile(true);
                } else {
                    setIsMobile(false);
                }
            });
        }
    }, []);

    return (
        <VStack className={styles.aboutUs}>
            <Row className={styles.section_1}>
                <Col xs={24} sm={24} md={24} lg={9} xl={9} >
                    <div className={styles.background}>
                        {
                            isMobile ?
                                <Image width={391} height={372} priority src='/about-us-1-mobile.webp' alt="about_us_background_mobile" className={styles.backgroundImage} />
                                :
                                <Image width={1320} height={653} priority src='/about-us-1.webp' alt="about_us_background_web" className={styles.backgroundImage} />
                        }
                    </div>
                    <VStack className={styles.textBox}>
                        <div className={styles.smallHeader}>About us</div>
                        <div className={styles.header}>AVENA is more than just a custom application development company.</div>
                        <div className={styles.subtext}>We’re an extension of your team.</div>
                    </VStack>
                </Col>
            </Row>

            <Row className={styles.section_2}>
                <Col className={styles.textContainer} xs={24} sm={24} md={24} lg={13} xl={13} >
                    <div className={styles.title}>AVENA is a custom software development company that can help businesses achieve their goals. </div>
                    <div className={styles.description}>Our years of experience enable us to provide you with custom software development services that are unparalleled. Our development team has the expertise, knowledge, and experience to deliver customizable solutions that will grow your business.</div>
                </Col>
                <Col className={styles.imageContainer} xs={24} sm={24} md={24} lg={11} xl={11} >
                    {
                        isMobile ?
                            <Image width={341} height={223} alt="about_us_background_2_mobile" src='/about-us-2-mobile.webp' className={styles.image} />
                            :
                            <Image width={611} height={402} src='/about-us-2.webp' alt="about_us_background_2_web" className={styles.image} />
                    }
                </Col>
            </Row>
            <Row className={styles.section_3}>
                <Col className={styles.divider} />
                <Col className={styles.textContainer} xs={24} sm={24} md={24} lg={24} xl={24} >
                    <div>We are transparent, keep our word, and provide excellent value for money with high-quality code and support.</div>
                </Col>
                <Col className={styles.divider} />
            </Row>

            <VStack className={styles.section_4}>
                <Row className={styles.first_row} style={{ gap: '25px' }}>
                    <Col className={styles.first_box} xs={24} sm={24} md={14} lg={15} xl={15} style={{ gap: '0px' }}>
                        {
                            isMobile ?
                                <Image width={361} height={330} src='/about-us-3-mobile.webp' alt="about_us_background_3_mobile" className={styles.background_image} />
                                :
                                <Image width={1320} height={653} src='/about-us-3.webp' alt="about_us_background_3_web" className={styles.background_image} />
                        }
                        <Row>
                            <Col xs={24} sm={24} md={24} lg={24} xl={10}>
                                <div className={styles.textContainer}>
                                    Our team of experts is made up of senior consultants who have years of experience in custom software solutions for all types of businesses.
                                </div>
                            </Col>
                        </Row>
                    </Col>
                    <Col className={styles.second_box} xs={24} sm={24} md={10} lg={9} xl={9}>
                        <div className={styles.textContainer}>
                            You can trust us to think through your requirements and deliver a solution that meets your needs.
                        </div>
                    </Col>
                </Row>
                <Row className={styles.second_row} style={{ gap: '25px' }}>
                    <Col className={styles.first_box} xs={24} sm={24} md={10} lg={9} xl={9}>
                        <div className={styles.textContainer}>
                            Hire our custom software developers today.
                        </div>

                    </Col>
                    <Col className={styles.second_box} xs={24} sm={24} md={14} lg={15} xl={15}>
                        <Image width={1320} height={653} src='/about-us-4.webp' alt="about_us_background_4" className={styles.background_image} />
                        <Row>
                            <Col className={styles.textContainer} xs={24} sm={24} md={24} lg={17} xl={17}>
                                <div className={styles.title}>AVENA is more than just a custom application development company. </div>
                                <div className={styles.description}>We understand that you need a partner who can work with your project on your timeline at an affordable price.</div>
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </VStack>

            <Row className={styles.section_5} style={{ gap: '0px' }}>
                {
                    isMobile ?
                        (
                            <>
                                <div className={styles.imageBox}>
                                    <Image width={361} height={344} src='/about-us-5-mobile.webp' alt="about_us_background_5_mobile" className={styles.image} />
                                </div>
                                <div className={styles.textBox}>
                                    <div className={styles.smallText}>We assist businesses and individuals in adapting as well as adopting digital transformation. </div>
                                    <div className={styles.bigText}>Our aim is to change people’s lives and improve businesses with our progressive and innovative technology solutions.</div>
                                </div>
                                <div className={styles.imageBox}>
                                    <Image width={361} height={344} src='/about-us-6-mobile.webp' alt="about_us_background_6_mobile" className={styles.image} />
                                </div>
                                <div className={styles.textBox}>
                                    <div className={styles.bigText}>We start by listening to the issues, requirements, challenges and objectives. </div>
                                    <div className={styles.smallText}>The process continues with an effort to understand the business, market sector and competitors to develop information which is combined with our technical knowledge, expertise and research in order to provide the best solution at the lowest cost.</div>
                                </div>
                            </>
                        )
                        :
                        (
                            <>
                                <Col xs={24} sm={24} md={12} lg={12} xl={12} className={styles.textBox}>
                                    <div className={styles.smallText}>We assist businesses and individuals in adapting as well as adopting digital transformation. </div>
                                    <div className={styles.bigText}>Our aim is to change people’s lives and improve businesses with our progressive and innovative technology solutions.</div>
                                </Col>
                                <Col xs={24} sm={24} md={12} lg={12} xl={12} className={styles.imageBox}>
                                    <Image width={682} height={650} src='/about-us-6.webp' alt="about_us_background_6_web" className={styles.image} />
                                </Col>
                                <Col xs={24} sm={24} md={12} lg={12} xl={12} className={styles.imageBox}>
                                    <Image width={682} height={650} src='/about-us-5.webp' alt="about_us_background_5_web" className={styles.image} />
                                </Col>
                                <Col xs={24} sm={24} md={12} lg={12} xl={12} className={styles.textBox}>
                                    <div className={styles.bigText}>We start by listening to the issues, requirements, challenges and objectives. </div>
                                    <div className={styles.smallText}>The process continues with an effort to understand the business, market sector and competitors to develop information which is combined with our technical knowledge, expertise and research in order to provide the best solution at the lowest cost.</div>
                                </Col>
                            </>
                        )
                }
            </Row>
            <div style={{ padding: '0px 13px' }}>
                <ContactUsForm />
            </div>

        </VStack>
    )
}

export default AboutUs;